export default __webpack_public_path__ + "static/media/480_portfolio03-jp-mobile.922c1846.png";